import { render, staticRenderFns } from "./ConfirmToTeacher.vue?vue&type=template&id=b4817f7a&"
import script from "./ConfirmToTeacher.vue?vue&type=script&lang=js&"
export * from "./ConfirmToTeacher.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmToTeacher.vue?vue&type=style&index=0&id=b4817f7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports